export default {
    paths: {
        '/files': 11,
        '/devices': 11,
        '/busy/schedules': 11,
        '/facilities': 11,
        '/rates': 11,
        '/frees/schedules': 11,
        '/discounts': 11,
        '/events': 14,
        '/activities': 15,
        '/teachers': 15,
        '/waitingLists': 15,
        '/payments': 12,
        '/tickets': 12,
        '/remittences': 16,
        '/roles': 11,
        '/configurations': 11,
    },
};
